import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.css']
})
export class PageContentComponent implements OnInit {

  @Input() narrow = false;

  constructor() {
  }

  ngOnInit(): void {
  }

}
